import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-faq',
  standalone: true,
  imports: [],
  template: `
    <div
      class="rounded-2xl overflow-hidden transition-all duration-300"
      style="border:1px solid var(--theme-border);background:var(--glass-bg)"
      [style.border-color]="isExpanded === index ? 'rgba(0,140,240,0.3)' : 'var(--theme-border)'"
    >
      <!-- Question row -->
      <button
        type="button"
        class="w-full flex justify-between items-center gap-4 px-6 py-5 text-left transition-colors"
        (click)="expand()"
        [attr.aria-expanded]="isExpanded === index"
      >
        <span
          class="font-display font-semibold text-base leading-snug"
          style="color:var(--theme-text)"
        >
          {{ question }}
        </span>

        <!-- +/- icon -->
        <span
          class="shrink-0 w-7 h-7 rounded-full flex items-center justify-center transition-all duration-300"
          [style.background]="isExpanded === index ? 'rgba(0,140,240,0.2)' : 'var(--glass-bg)'"
          [style.border]="isExpanded === index ? '1px solid rgba(0,140,240,0.4)' : '1px solid var(--theme-border)'"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="w-3.5 h-3.5 transition-transform duration-300"
            [style.color]="isExpanded === index ? '#008CF0' : 'var(--theme-text-muted)'"
            [style.transform]="isExpanded === index ? 'rotate(45deg)' : 'none'"
            viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"
          >
            <path stroke-linecap="round" stroke-linejoin="round" d="M12 4v16M4 12h16"/>
          </svg>
        </span>
      </button>

      <!-- Answer panel — CSS height transition -->
      <div
        class="overflow-hidden transition-all duration-400 ease-out"
        [style.max-height]="isExpanded === index ? '600px' : '0'"
        [style.opacity]="isExpanded === index ? '1' : '0'"
      >
        <div class="px-6 pb-5">
          <div
            class="pt-1 mb-4 text-sm leading-relaxed"
            style="color:var(--theme-text-dim);border-top:1px solid var(--theme-border)"
          >
            <br/>{{ answer }}
          </div>
          @if (src) {
            <img
              [src]="src"
              class="w-full max-w-sm rounded-xl object-cover"
              alt=""
              loading="lazy"
              decoding="async"
            />
          }
        </div>
      </div>
    </div>
  `,
})
export class FaqComponent {
  @Input() question = '';
  @Input() answer = '';
  @Input() src = '';
  @Input() index: number | null = null;
  @Input() isExpanded: number | null = null;

  @Output() toggled = new EventEmitter<void>();

  expand(): void {
    this.toggled.emit();
  }
}
